import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { IndexedDbUnitService } from '../indexeddb-unit.service';
import { PollTypeEnum } from '../../enums/poll-type.enum';

@Injectable()
export class ConfigGuard implements CanActivate {
  constructor(
    private readonly router: Router,
    private readonly indexedDbUnitService: IndexedDbUnitService
  ) {}

  async canActivate() {
    try {
      const unit = await this.indexedDbUnitService.getUnit();

      if (!unit?.device?.id) {
        return true;
      }

      // A poll gravada no IndexedDB é a do tipo do device vinculado (o setup
      // grava apenas uma). Navegar sempre com pollId levava o device de reserva
      // para uma rota cuja poll não existe em cache.
      const pollId =
        unit.device.typePoll === PollTypeEnum.Satisfaction
          ? unit.pollId
          : unit.pollDishReservationId;

      if (!pollId) {
        return true;
      }

      this.router.navigate([
        '/unit',
        unit.id,
        'device',
        unit.device.id,
        'poll',
        pollId
      ]);
      return false;
    } catch (error) {
      console.error('Erro ao verificar configuração da unidade:', error);
      return true;
    }
  }
}
